<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue'

import { customElementPropsKey } from '@/types/customElementProps.types'
import { inject } from 'vue'

const templateProps = inject(customElementPropsKey)
</script>

<template>
  <div>
    <PageTitle
      :title="templateProps?.infoContent?.message ?? ''"
      :hide-generic-message="true"
    />
    <v-btn variant="text" data-cy="info-view-action-button" :href="templateProps?.infoContent?.buttonHref">{{
      $t(templateProps?.infoContent?.buttonLabel ?? '')
    }}</v-btn>
  </div>
</template>
